import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const ForgotPassword = () => {
    return (
        <>
            <Header as="h1" id="forgot-header">Forgot Password</Header>
        </>
    );
};

export default ForgotPassword;